export const blockIconsCommonactionsBuildNew = (
	<span className='material-symbols-outlined'>build</span>
);
